<?php

\Core\View::$template = function () {

    $html = '<div class="container"><div class="row">';
    $html_favorite = '';
    $pv = \Core\View::$page_vars;
    \ISOPHP\js_core::$console->log('pagevars: ', $pv);
    $rqd = $pv['request_data'];
    // $rqd_user_logged = $rqd['user_logged'];
    $session_user = \ISOPHP\core::$registry->getValue('user_logged')['user'];
    $rqd_user_logged = isset($session_user['id']) ? $session_user['id'] : '';
    \ISOPHP\js_core::$console->log('logged user id: ', $rqd_user_logged);

    foreach ($rqd['jobs'] as $one_job) {
        if ($rqd_user_logged !== '') {
            $invitation_button = '';
            if ( !empty($one_job['favorite']) ) {
                $favorite_button = '<span title="Remove from favourite list" class="remove_favorite" id="' . $one_job['id'] . '"><i class="fa fa-heart"></i></span>';
            } else {
                $favorite_button = '<span title="Add to favourite list" class="add_favorite" id="' . $one_job['id'] . '"><i class="fa fa-heart-o"></i></span>';
            }
            if ( !empty($one_job['applied']) ) {
                if(isset($one_job['applied'][0]['interview_at']) && ($rqd_user_logged == $one_job['applied'][0]['user_id'])){
                    $invitation_button = '<h3 class="interview_invite btn job_btn">
                    <span title="Invited for interview" class="invited" id="interview_invited_' . $one_job['id'] . '">
                    <i class="fa fa-handshake-o"></i></i></span></h3>';
                }

                $apply_button = '<span title="Already applied" class="applied" id="apply_' . $one_job['id'] . '"><i class="fa fa-thumbs-up"></i></i></span>';
            } else {
                $apply_button = '<span title="Apply to this Job" class="apply_job" id="apply_' . $one_job['id'] . '"><i class="fa fa-hand-o-up"></i></span>';
            }

            $html_favorite = '<div class="btn-fav">                                        
                                        ' . $invitation_button . '                                        
                                        <h3 class="job_apply btn job_btn">
                                        ' . $apply_button . '
                                        </h3>
                                        <h3 class="favourite_job btn job_btn">
                                        ' . $favorite_button . '
                                        </h3>
                                </div>';
        } else {
            $html_favorite = '';
        }

        $html = $html . '            
                <div id="jobsection_' . $one_job['id'] . '" class="col-sm-6 col-md-6 col-xs-12 col-12">
                    <div class="one_account">
                        <div class="row clearfix">
                            <div class="col-sm-12">
                                <p class="job_id_title">Job ID: <span class="job_id">' . $one_job['id'] . '</span></p>
                            </div>
                        </div>
                        <div id="job_' . $one_job['id'] . '" class="row jobs-details">
                            <div class="col-sm-12">
                                <h6 class="job_title list_job_title">' . $one_job['title'] . '</h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">

                                <div class="label_wrap">
                                    <p class="job_lebels job_job_type"><i class="fa fa-graduation-cap"></i>' . $one_job['job_type'] . '</p>
                                    <p class="job_lebels job_job_level"><i class="fa fa-briefcase  "></i>' . $one_job['job_level'] . '</p>
                                    <p class="job_lebels job_location"><i class="fa fa-map-marker"></i>' . \ISOPHP\core::$php->explode(',', $one_job['job_location'])[0] . '</p>
                                </div>

                            </div>

                        </div>
                        <div class="row">
                            <div class="col-sm-12">

                                <p class="job_description_title" style="display: none;">Description</p>
                                <p class="job_description">' . substr($one_job['description'],0,100).(strlen($one_job['description']) > 100 ? " ...." : ""). '</p>

                            </div>

                        </div>

                    ';
        $html = $html . $html_favorite . '</div>
                </div>
                <!--<div class="col-sm-6 col-md-6 col-xs-12  col-12 job_des_holder  xs-no-padding">
                    <div class="job_des_wrap">
                        This section will remain hide until any of the job is selected. Once it is selected, This section will be viewed. Waiting for developers contribution.....
                    </div>
                </div>-->
            ';

    }
    $html = $html . '</div></div>';

    return $html;

};


// WEBPACK FOOTER //
// app/JobList/View/AllJobsForUser.php